import { ButtonDefinition, closeAllPanels, showAlert } from './uiUtils';
import { ENGINE_TYPES } from '../../../../src/commonConstants';
import { EngineId } from '../../../../src/commonTypes';
import { updateBoardEngine, getPdfContextFromFileSearch } from '../apiRequests';
import { isBoardOwner } from './toolsUI';
import InspireGraph from '../graphs/InspireGraph';
import { MoodboardGraph } from '../graphs';

const boardEngineButton = document.querySelector('#engine-select');
if (boardEngineButton) {
	boardEngineButton.addEventListener('click', () => {
		if (!isBoardOwner()) {
			showAlert('Only the board owner can change the board engine');
			return;
		}

		const { engine: engineId, hasAdvancedAi } = document.body.dataset as {
			engine: EngineId;
			hasAdvancedAi: string;
		};
		const advancedAI = hasAdvancedAi === 'true';

		const engine = Object.values(ENGINE_TYPES).find((e) => e.id === engineId)!;
		let remainingEngines = Object.values(ENGINE_TYPES).filter((e) => e !== engine);

		showAlert(
			`Currently using the ${engine.name} Engine`,
			remainingEngines.map(
				(e) =>
					({
						disabled: e.id === 'Create' ? !advancedAI : false,
						label: `Switch to ${e.name}`,
						iconUrl: `/assets/icon/dashboard/${e.id.toLowerCase()}.png`,
						onClick: () => {
							boardEngineButton.classList.remove(`border-${engineId.toLowerCase()}`);
							updateBoardEngine(document.body.dataset.boardId!, e.id);
						},
					}) as ButtonDefinition
			)
		);
	});
}

const pdfContextButton = document.querySelector('#context-select');
if (pdfContextButton) {
	pdfContextButton.addEventListener('click', async () => {
		closeAllPanels();
		let newPosition = { x: -380, y: 50 };

		const hash = location.hash;
		if (hash.includes('synthesise')) {
			const context = await getPdfContextFromFileSearch(document.body.dataset.boardId!);
			const synthesiseGraph = globalThis.neuroCreate.graph as MoodboardGraph;
			synthesiseGraph.addNodeNearPoint(newPosition, context, undefined, undefined);
		} else {
			const context = await getPdfContextFromFileSearch(document.body.dataset.boardId!);
			const inspireGraph = globalThis.neuroCreate.graph as InspireGraph;
			inspireGraph.addNodeNearPoint(newPosition, context, undefined, undefined);
		}
	});
}
